const ScrollUtil = (function () {
	return {
		scrollToTop: function (position) {
			position = position || 0;
			var current_position = ScrollUtil.getScrollTop();

			if (current_position <= position) {
				return;
			}

			ScrollUtil.scrollTo(position);
		},
		scrollToBottom: function (position) {
			position = position || 0;
			var current_position = ScrollUtil.getScrollTop();

			if (position <= current_position) {
				return;
			}

			ScrollUtil.scrollTo(position);
		},
		scrollTo: function (position, callback) {
			var $body = $('html, body');
			position = position || 0;

			var current_position = ScrollUtil.getScrollTop();

			if (Math.abs(current_position - position) > 400) {
				$body.scrollTop(position + Math.sign(current_position - position) * 400);
			}

			$body.animate({
				scrollTop: position
			}, 300, 'swing', function () {
				$body.scrollTop(position);

				if (typeof callback === 'function') {
					callback();
				}
			});
		},
		getScrollTop: function () {
			return $(window).scrollTop();
		}
	};
})();

export default ScrollUtil;
